// extracted by mini-css-extract-plugin
module.exports = {"parent":"speech_parent__1nFiJ"};